import { defineComponent as _defineComponent } from 'vue'
import { useStorage } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletAssetSetIdentity',
  setup(__props) {

const rememberIdentity = useStorage('remember-identity', false)

return { __sfc: true,rememberIdentity }
}

})